import { EXPIRATION_LEAD_TIME_SECONDS } from "../auth/userServices";
import { useAppSelector } from "../store/hooks";
import { useIsUserAuthenticated } from "./useIsUserAuthenticated";

export const useIsAdminUser = () => {
  const { isAdmin } = useAppSelector((state) => state.auth);
  const isUserAuthenticated = useIsUserAuthenticated();

  return (): boolean => {
    return isAdmin && isUserAuthenticated();
  };
};
